import { ReturnAffectifExpertise } from './ReturnAffectifExpertise';
import { ReturnAffectifChallenges } from './ReturnAffectifChallenges';

import { ReasonsSection } from '../ReasonsSection';

export const ReturnAffectifSection = ({ handleWhatsAppClick }) => (
<section className="py-12 md:py-16 bg-black relative overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img 
            src="https://images.unsplash.com/photo-1716980980076-5fed3348f1d5" 
            alt="Retour Affectif Rapide Guadeloupe - Sorcier Vaudou Marabout Africain" 
            className="w-full h-full object-cover opacity-15"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/95 to-black"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block bg-red-600/20 border border-red-600/40 text-red-400 px-6 py-2 rounded-full text-sm font-semibold mb-6">
                ❤️ Spécialité N°1 du Sorcier Vaudou Maître Diamma
              </span>
              <h2 className="text-4xl md:text-6xl font-bold mb-8 text-red-600 leading-tight">
                Retour Affectif Rapide et Définitif
              </h2>
              <h3 className="text-2xl md:text-3xl font-semibold mb-8 text-yellow-400">
                Par le Grand Sorcier Vaudou Maître Diamma
              </h3>
            </div>

            <div className="story-columns grid grid-cols-1 lg:grid-cols-2 gap-12 mb-12">
              <ReturnAffectifChallenges />

              <ReturnAffectifExpertise />
            </div>

            <ReasonsSection onContact={handleWhatsAppClick} />
          </div>
        </div>
      </section>
);
